import React from 'react'
import "./common.css"
export const TableContainer = ({children,className,...props}) => {
  return (
    <div className={`table_container_con ${className}`} {...props}>
        {children}
    </div>
  )
}
